import { registerKadenceTracking } from './main/tracking.js';

const { register } = window.sitchco;
register(registerKadenceTracking);
